const INITIAL_STATE = {
  categorias: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'DIARIA_CATEGORIA_FETCH':
      return { ...state, categorias: action.payload }
    default:
      return state
  }
}
